"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGameFirstHalfTime = exports.isGameFinish = exports.hasGameCasualty = exports.getGameFanBonus = exports.getGameFan = exports.getDateStartHalfTime = exports.getDateEndHalfTime = exports.GAME_TYPE = exports.GAME_STATUS = exports.CLEAN_HISTORY_DAY = void 0;
const random_1 = require("./random");
const time_1 = require("./time");
const CLEAN_HISTORY_DAY = 30;
exports.CLEAN_HISTORY_DAY = CLEAN_HISTORY_DAY;
var GAME_TYPE;
(function (GAME_TYPE) {
    GAME_TYPE["DIVISION"] = "division";
    GAME_TYPE["FRIENDLY"] = "friendly";
    GAME_TYPE["OPEN"] = "open";
    GAME_TYPE["PLAYOFF"] = "playoff";
})(GAME_TYPE || (exports.GAME_TYPE = GAME_TYPE = {}));
var GAME_STATUS;
(function (GAME_STATUS) {
    GAME_STATUS[GAME_STATUS["WAITING"] = 0] = "WAITING";
    GAME_STATUS[GAME_STATUS["BEFORE"] = 1] = "BEFORE";
    GAME_STATUS[GAME_STATUS["ONGOING"] = 2] = "ONGOING";
    GAME_STATUS[GAME_STATUS["TD"] = 3] = "TD";
    GAME_STATUS[GAME_STATUS["END"] = 4] = "END";
    GAME_STATUS[GAME_STATUS["FINISH"] = 5] = "FINISH";
    GAME_STATUS[GAME_STATUS["HALFTIME"] = 6] = "HALFTIME";
})(GAME_STATUS || (exports.GAME_STATUS = GAME_STATUS = {}));
const isGameFinish = (game) => {
    return game.status === GAME_STATUS.END || game.status === GAME_STATUS.FINISH;
};
exports.isGameFinish = isGameFinish;
const hasGameCasualty = (game) => {
    return game.type !== GAME_TYPE.FRIENDLY;
};
exports.hasGameCasualty = hasGameCasualty;
const getGameFanBonus = (game) => {
    // if (game.type === GAME_TYPE.FRIENDLY) {
    //   return -5;
    // }
    if (game.type === GAME_TYPE.PLAYOFF) {
        return 5;
    }
    return 0;
};
exports.getGameFanBonus = getGameFanBonus;
const getGameFan = (game) => {
    return (0, random_1.d6)(2) + getGameFanBonus(game);
};
exports.getGameFan = getGameFan;
const getDateStartHalfTime = (game) => {
    const start = new Date(game.date_start);
    const end = new Date(game.date_end);
    return new Date(start.getTime() +
        (end.getTime() - start.getTime()) / 2 -
        ((0, time_1.getTime)(time_1.TYPE_TIMER.HALF_TIME_PAUSE) * 1000) / 2);
};
exports.getDateStartHalfTime = getDateStartHalfTime;
const getDateEndHalfTime = (game) => {
    const half = getDateStartHalfTime(game);
    return new Date(half.getTime() + (0, time_1.getTime)(time_1.TYPE_TIMER.HALF_TIME_PAUSE) * 1000);
};
exports.getDateEndHalfTime = getDateEndHalfTime;
const isGameFirstHalfTime = (game) => {
    const now = new Date(Date.now());
    return getDateStartHalfTime(game).getTime() - now.getTime() > 0;
};
exports.isGameFirstHalfTime = isGameFirstHalfTime;
